import React from 'react';
import SmallContainer from '../containers/small/small-container';
import { useNavigate } from 'react-router-dom';

function AppstreamStatus({ isReady, onAppstreamClick, onBackToLogin }) {
  const navigate = useNavigate();
  return (
    <SmallContainer>
      {isReady ? (
        <>
          <p
            style={{
              fontWeight: 'bold',
              fontSize: '1.1rem',
              marginBottom: '2rem',
            }}
          >
            Your FACES™ instance is ready!
          </p>
          <button onClick={onAppstreamClick} style={{ width: '100%' }}>
            OPEN FACES™
          </button>
        </>
      ) : (
        <>
          <p
            style={{
              fontWeight: 'bold',
              fontSize: '1.1rem',
              marginBottom: '2rem',
            }}
          >
            No seats available. Contact your administrator and try again later.
          </p>
          <button
            onClick={() => {
              navigate('/menu');
            }}
            style={{ width: '100%' }}
          >
            BACK TO LOGIN
          </button>
        </>
      )}
    </SmallContainer>
  );
}

export default AppstreamStatus;
